import { render } from "./NotFound.vue?vue&type=template&id=c191a88a&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=c191a88a&scoped=true&lang=css"

import exportComponent from "/buddy/tradeapponeonline/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c191a88a"]])

export default __exports__